import { sitesUiSlice } from '@shared/stores/SitesUiReducer';
import { combineReducers } from '@reduxjs/toolkit';
import { leakReducer } from './entity/leaks/LeakReducer';
import { loggerProgrammingReducer } from './entity/loggerProgramming/LoggerProgrammingReducer';
import mapSlice from './slices/map/map.reducer';
import { settingsReducer } from './entity/settings/SettingsReducer';
import { siteReducer } from './entity/sites/SitesReducer';
import { surveyMeasurementsReducer } from './entity/surveyMeasurements/SurveyMeasurementsReducer';
import { preferencesReducer } from './entity/preferences/PreferencesReducer';
import { preferencesUiSlice } from '@shared/stores/PreferencesUiReducer';
import { accountsReducer } from './library-stores/accounts';
import { userProfileReducer } from './library-stores/user-profile';
import { surveysReducer } from './entity/surveys/SurveysReducer';
import { surveysUiSlice } from '@shared/stores/SurveysUiReducer';
import { sitesListUiSlice } from '@shared/stores/SitesListUiReducer';
import { settingsUiSlice } from '@shared/stores/SettingsUiReducer';
import { loggerProgrammingUiSlice } from '@shared/stores/LoggerProgrammingUiReducer';
import { leakUiSlice } from '@shared/stores/LeakUiReducer';

export const rootReducer = combineReducers({
  [userProfileReducer.slice.name]: userProfileReducer.slice.reducer,
  [accountsReducer.slice.name]: accountsReducer.slice.reducer,
  [siteReducer.slice.name]: siteReducer.slice.reducer,
  [leakReducer.slice.name]: leakReducer.slice.reducer,
  [sitesUiSlice.name]: sitesUiSlice.reducer,
  [sitesListUiSlice.name]: sitesListUiSlice.reducer,
  [settingsReducer.slice.name]: settingsReducer.slice.reducer,
  [settingsUiSlice.name]: settingsUiSlice.reducer,
  [mapSlice.name]: mapSlice.reducer,
  [loggerProgrammingUiSlice.name]: loggerProgrammingUiSlice.reducer,
  [loggerProgrammingReducer.slice.name]: loggerProgrammingReducer.slice.reducer,
  [leakUiSlice.name]: leakUiSlice.reducer,
  [surveyMeasurementsReducer.slice.name]: surveyMeasurementsReducer.slice.reducer,
  [preferencesReducer.slice.name]: preferencesReducer.slice.reducer,
  [preferencesUiSlice.name]: preferencesUiSlice.reducer,
  [surveysReducer.slice.name]: surveysReducer.slice.reducer,
  [surveysUiSlice.name]: surveysUiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
